import { render, staticRenderFns } from "./Acknowledgements.vue?vue&type=template&id=3a827dc6&scoped=true&"
import script from "./Acknowledgements.vue?vue&type=script&lang=js&"
export * from "./Acknowledgements.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a827dc6",
  null
  
)

export default component.exports